import {
  BarChart3, CalendarClock, CalendarDays, CalendarSearch, ClipboardList, History, Inbox, LayoutDashboard, ListChecks,
  MessageSquare, RotateCw, Shield, UserCircle, UserX, Users, Voicemail,
} from 'lucide-react';

// Menü der Seitenleiste. Steht hier und nicht im Layout, weil auch die
// Meldung über „Feedback" den Menüpunkt der aktuellen Seite nachschlägt.

export interface NavItem {
  to: string;
  label: string;
  icon: typeof LayoutDashboard;
  end?: boolean;
  privileged?: 'team' | 'admin' | 'insights' | 'scripts';
  section: string;
}

// Gruppierte, klar benannte Navigation. Reihenfolge hier = Anzeigereihenfolge.
export const NAV_SECTIONS: { id: string; label: string }[] = [
  { id: 'start',    label: '' },
  { id: 'calls',    label: 'Anrufen' },
  { id: 'contacts', label: 'Kontakte' },
  { id: 'messages', label: 'Nachrichten' },
  { id: 'plan',     label: 'Mein Plan' },
  { id: 'mgmt',     label: 'Verwaltung' },
];

export const NAV_ITEMS: NavItem[] = [
  { to: '/',             label: 'Dashboard',      icon: LayoutDashboard, end: true, section: 'start' },
  { to: '/queue',        label: 'Anrufliste',     icon: ListChecks,    section: 'calls' },
  { to: '/callbacks',    label: 'Wiedervorlagen', icon: CalendarClock, section: 'calls' },
  { to: '/history',      label: 'Verlauf',        icon: History,       section: 'calls' },
  { to: '/voicemails',   label: 'Mailbox',        icon: Voicemail,     section: 'calls' },
  { to: '/back-on-track',label: 'Reaktivierung',  icon: RotateCw,      section: 'calls' },
  { to: '/leads',        label: 'Interessenten',  icon: Inbox,         section: 'contacts' },
  { to: '/abandoned-bookings', label: 'Abgebrochene Buchungen', icon: UserX, section: 'contacts' },
  { to: '/customers',    label: 'Kunden',         icon: UserCircle,    section: 'contacts' },
  { to: '/campaign',     label: 'Nachrichten',    icon: MessageSquare, section: 'messages' },
  { to: '/availability', label: 'Verfügbarkeit',  icon: CalendarSearch,section: 'plan' },
  { to: '/schedule',     label: 'Wochenplan',     icon: CalendarDays,  section: 'plan' },
  { to: '/skripte',      label: 'Skripte',        icon: ClipboardList, privileged: 'scripts', section: 'mgmt' },
  { to: '/insights',     label: 'Auswertungen',   icon: BarChart3, privileged: 'insights', section: 'mgmt' },
  { to: '/team',         label: 'Team',           icon: Users,  privileged: 'team',  section: 'mgmt' },
  { to: '/admin',        label: 'Admin',          icon: Shield, privileged: 'admin', section: 'mgmt' },
];

/** Seiten ohne eigenen Menüpunkt, die trotzdem einen Namen verdienen. */
export const NAV_ZUSATZ: ReadonlyArray<{ to: string; label: string }> = [
  { to: '/settings', label: 'Einstellungen' },
  { to: '/wilmersdorf-sommer', label: 'Sommerferien Wilmersdorf' },
];
